import { useEffect, useState } from "react";
import Sideview from "../components/Sideview";
import FastCounter from "../components/FastCounter";

const SplashPage = (): JSX.Element => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    // Set fadeIn to true after the component mounts, triggering the fade-in effect
    setFadeIn(true);
  }, []);

  return (
    <div
      className={`transition-opacity duration-1000 ${
        fadeIn ? "opacity-100" : "opacity-0"
      }`}
    >
      <video
        className="fixed top-0 left-0 w-full h-screen object-cover"
        autoPlay
        loop
        muted
        playsInline
      >
        <source
          src="https://eraxftnbodkbhmdl.public.blob.vercel-storage.com/hotnyclowres-EwE7jZZeLfwslGYtqjiIpYjT9K7KVO.mov"
          type="video/mp4"
        />
        {/* <source
          src="https://eraxftnbodkbhmdl.public.blob.vercel-storage.com/trainclip3-vjm6uH0SviMkCBwgObdIjXYUAdHk4d.mov"
          type="video/mp4"
        /> */}
        {/* <source
          src="https://eraxftnbodkbhmdl.public.blob.vercel-storage.com/background-p8CCMf6KEx1zkyhStkCIRMGk2qOTp7.mov"
          type="video/mp4"
        /> */}
      </video>
      <div>
      <div className="fixed top-0 left-0 w-full z-20 bg-transparent">
        <div className="flex flex-row pl-6">
          <h1 className="font-syne-mono mr-[15px] no-underline text-white/90 pt-[18px] text-2xl font-medium">
            <strong>New York</strong> Lab
          </h1>
          <div className="flex items-end pb-[2px] ml-auto pr-6 pt-1">
            <Sideview />
          </div>
        </div>
        <div className="flex pl-6 pb-3">
          <FastCounter />
        </div>
        {/* <p className="text-white/90 text-sm px-6">
          Exploring issues affecting New Yorkers through the lens of technology, art, and curiosity.
        </p> */}
        </div>
        <div className="relative z-10 w-full">
        <h1 className="text-white/90 text-sm px-6 pt-24 max-w-xl h-[30vh]">
          We are a coalition of researchers, engineers, and advocates working toward cleaner, cooler subway stations.
        </h1>
        {/* <p className="text-xs px-6 my-5 text-white max-w-xl">
          We’re installing sensors in train stations across the city to gather real
          data on heat and humidity underground. Whether this data fuels
          advocacy, sparks art, or starts new conversations, we believe the
          first step is making it public.
        </p> */}
        {/* <p className="text-xs px-6 my-5 text-white max-w-xl">We are a coalition of researchers, engineers, policymakers, and advocates pushing for cleaner, cooler subway stations.</p> */}
        <section id="goals" className="text-white/90 px-6 pb-10 max-w-5xl">
          <h2 className="text-lg font-semibold mb-3">What We’re Working On</h2>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 shadow-lg">
              <h3 className="text-sm font-bold mb-2">Collecting long-term data</h3>
              <p className="text-xs">
                Measuring temperature, humidity, and air quality in subway stations to inform future mitigation strategies.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 shadow-lg">
              <h3 className="text-sm font-bold mb-2">Promoting adaptable solutions</h3>
              <p className="text-xs">
                Chairs, water stations, and fans to protect riders and workers while big infrastructure projects unfold.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 shadow-lg">
              <h3 className="text-sm font-bold mb-2">Modeling underground conditions</h3>
              <p className="text-xs">
                Using our dataset to anticipate future climate impacts in the subway system.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 shadow-lg">
              <h3 className="text-sm font-bold mb-2">Building public accountability</h3>
              <p className="text-xs">
                Ensuring MTA solutions move quickly and equitably with transparency.
              </p>
            </div>
          </div>
        </section>

        <section id="press" className="text-white/90 px-6 pt-5 mb-40">
          <h2 className="text-lg font-semibold">Selected interviews and features about our work</h2>
          <ul className="text-sm mt-2">
            <li>
              <a href="https://www.theguardian.com/us-news/2026/aug/26/new-york-subway-extreme-heat" target="_blank" rel="noopener noreferrer" className="font-bold">
                "‘132F’: meet the man calling out NYC’s infernally hot subway stations"
              </a>
              — The Guardian
            </li>
            <li>
              <a href="https://www.readfeedme.com/p/did-you-know-that-theres-a-lab-under" target="_blank" rel="noopener noreferrer" className="font-bold">
                "Did you know that there's a lab under the subway?"
              </a>
              — Feed Me
            </li>
            <li>
              <a href="https://news.climate.columbia.edu/2025/08/19/how-do-we-fix-the-hellish-heat-of-the-new-york-city-subway-system/" target="_blank" rel="noopener noreferrer" className="font-bold">
                "How Do We Fix the Hellish Heat of the New York City Subway System?"
              </a>
              — Columbia Climate School
            </li>
          </ul>
        </section>
          </div>
      </div>
    </div>
  );
};

export default SplashPage;
